enum TriggerTargetType {
    Field = 1,
    Profile = 2,
    UserStatus = 3,
    FormStatus = 4,
    SubmissionStatus = 5
}

export { TriggerTargetType };